<template>
  <canvas v-show="ready" id="exportableComplete" ref="exportableComplete" width="400" height="400"></canvas>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";

const CHART_COLORS = {
  blue: "rgb(54, 162, 235)",
  purple: "rgb(153, 102, 255)",
  green: "rgb(75, 192, 192)",
  yellow: "rgb(255, 205, 86)",
  orange: "rgb(255, 159, 64)",
  red: "rgb(255, 99, 132)",
  grey: "rgb(201, 203, 207)"
};

export default {
  props: ["client_customer", "product", "product_type"],
  data() {
    return {
      ready: false,
      labels: [],
      data: [
        {
          label: "Pallets",
          data: [],
          backgroundColor: Object.values(CHART_COLORS),
          borderWidth: 1
          // datalabels: {
          //   // anchor: "start",
          //   formatter: function (value, context) {
          //     const total = context.dataset.data.reduce((acc, value) => parseInt(value) + acc, 0);
          //     return new Intl.NumberFormat("es-CL").format(parseInt((value / total) * 100)) + " %";
          //   }
          // }
        }
      ]
    };
  },
  async mounted() {
    const self = this;
    try {
      const response = await this.$axios({
        method: "GET",
        url: `production/dashboard/stock/exportable_complete?client_customer=${this.client_customer}&product=${this.product}&product_type=${this.product_type}`,
        headers: {
          "Content-Type": "application/json"
        }
      });
      this.loading = false;
      this.labels = response.data.labels;
      const desiredElements = 6;
      const lastValue = response.data.dataset.slice(desiredElements).reduce((acc, val) => acc + parseFloat(val), 0);
      this.labels = response.data.labels;
      this.labels.length = desiredElements;
      this.labels.push("Otras");
      this.data[0].data = response.data.dataset;
      this.data[0].data.length = desiredElements;
      this.data[0].data.push(lastValue);
      // TODO: Fix sum_boxes
      const lastBoxesValue = response.data.sum_boxes.slice(desiredElements).reduce((acc, val) => acc + val, 0);
      this.data[0].sum_boxes = response.data.sum_boxes;
      this.data[0].sum_boxes.length = desiredElements;
      this.data[0].sum_boxes.push(lastBoxesValue);
      this.ready = true;
    } catch (error) {
      console.log(error);
      this.loading = false;
    }

    this.ready = true;

    let ctx = this.$refs.exportableComplete.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "doughnut",
      data: {
        labels: this.labels,
        datasets: this.data
      },
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "right"
          },
          datalabels: {
            color: "#043e73"
          },
          title: {
            display: true,
            align: "start",
            text: "Total pallets completos por formato"
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.formattedValue + " Pallets";
              },
              afterBody: function (context) {
                const index = context[0].dataIndex;
                return context[0].dataset.sum_boxes[0][index] + " Cajas";
              }
            }
          }
        },
        animation: {
          onComplete: function (animation) {
            setTimeout(() => {
              self.$emit("chart-ready");
            }, 500);
          }
        }
      }
    });
  }
};
</script>

<style></style>
